import axios from "../api";

export const listTermsAndConditionsAction = async (data) => {
  return new Promise((resolve, reject) => {
    axios
      .get(`/api/termsAndConditions/get-termsAndConditions`,{params: data})
      .then((response) => {
        resolve(response.data.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getTermsAndConditionsByIdAction = async (data) => {
  return new Promise((resolve, reject) => {
    axios
      .get(`/api/termsAndConditions/${data}`)
      .then((response) => {
        resolve(response.data.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const createTermsAndConditionsAction = async (data) => {
  return new Promise((resolve, reject) => {
    axios
      .post("/api/termsAndConditions/upload-termsAndConditions", data)
      .then((response) => {
        resolve(response.data.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
export const publishTermsAndConditions = async (data) => {
  return new Promise((resolve, reject) => {
    axios
      .patch(`/api/termsAndConditions/publish`, data)
      .then((response) => {
        resolve(response.data.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const updateTermsAndConditionsAction = async (data, id) => {
  return new Promise((resolve, reject) => {
    axios
      .put(`/api/termsAndConditions/${id}`, data)
      .then((response) => {
        resolve(response.data.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
